import { useState } from "react";
import { getMobilBankState } from "./useNavigateMBC";
import { useLocation } from "react-router";

function useNavigateState() {
	const location = useLocation();
	const [navigateState] = useState({ ...(getMobilBankState().navigasjonState ?? {}), ...(location.state ?? {}) });
	return navigateState;
}
export default useNavigateState;
